import mixpanel from "mixpanel-browser";

const parseUser = (user: any) => {
  return {
    name: user.displayName,
    email: user.email,
    number: user.phoneNumber,
    uid: user.uid,
    createdAt: user.metadata.createdAt,
    emailVerified: user.emailVerified,
  };
};

export const mixpanelSignup = (
  method: "email" | "google" | "apple",
  user: any,
) => {
  const ref = localStorage.getItem("referralCode");
  const data = {
    "Signup method": method,
    user: parseUser(user),
  };
  if (ref) {
    Object.assign(data, { referralCode: ref });
  }
  mixpanel.identify(user.uid);
  mixpanel.track("Signup event", data);
  mixpanel.people.set({
    $email: user.email,
    name: user.displayName,
    created: user.createdAt,
    lastLogin: user.createdAt,
  });
};

export const mixpanelSignin = (
  method: "email" | "google" | "apple",
  user: any,
) => {
  mixpanel.identify(user.uid);
  mixpanel.track("Signin event", {
    "Signin method": method,
    user: { ...parseUser(user) },
  });
  mixpanel.people.set({
    $email: user.email,
    name: user.displayName,
    created: user.createdAt,
    phone: user.phoneNumber,
    lastLogin: user.lastLoginAt,
  });
};

export const mixpanelExchange = (
  id: string,
  exchangeName: string,
  action: "add" | "delete",
) => {
  mixpanel.identify(id);
  mixpanel.track("Exchange event", {
    Action: action,
    Name: exchangeName,
  });
};

export const mixpanelOpenNotification = (id: string) => {
  mixpanel.identify(id);
  mixpanel.track("Open notifications event");
};

export const mixpanelSignout = () => {
  mixpanel?.reset();
};

export const dubTrackSignup = async (
  method: "email" | "google" | "apple",
  user: any,
) => {
  try {
    // Track lead via server-side API route
    await fetch("/api/dub/track-lead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        eventName: "Sign up",
        customerExternalId: user.uid, // Use Firebase UID as unique customer ID
        customerName: user.displayName || undefined,
        customerEmail: user.email || undefined,
        customerAvatar: user.photoURL || undefined,
        metadata: {
          signupMethod: method,
          emailVerified: user.emailVerified || false,
        },
      }),
    });
  } catch (error) {
    console.error("Dub tracking error:", error);
  }
};
